<template>
  <v-container
    fluid
    grid-list-xl
    style="
      padding: 20px;
      height: 90vh;
      overflow: scroll;
      padding-bottom: 180px !important;
    "
  >
    <v-layout row wrap>
      <v-flex xs12 style="padding: 0 12px 10px">
        <v-card flat class="border-container">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  label="Buscar"
                  class="border-container"
                  prepend-inner-icon="search"
                  clearable
                  solo
                  flat
                  hide-details
                  v-model="search"
                  @keyup.enter="getItems"
                  @click:clear="clearSearch"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 style="padding: 0 12px 10px">
        <v-card flat class="border-container">
          <v-card-text class="px-0 py-0">
            <v-data-table
              :rows-per-page-items="[25, 50, 100]"
              rows-per-page-text="Registros por página"
              :headers="headers"
              :items="items"
              :total-items="totalItems"
              :loading="isLoading"
              :pagination.sync="pagination"
              @update:pagination="getItems"
              no-results-text="No se encontraron coincidencias"
              no-data-text="No hay registros"
              must-sort
            >
              <template v-slot:headers="props">
                <tr>
                  <td v-for="header in props.headers">
                    {{ header.text }}
                  </td>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr class="body-2 font-weight-regular">
                  <td>
                    <v-avatar
                      :tile="false"
                      size="30"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.normalObjUrl
                      "
                    >
                      <img
                        :src="props.item.imageStorage.normalObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-avatar v-else text-color="white">
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                  </td>
                  <td>{{ props.item.firstName }}</td>
                  <td>{{ props.item.lastName }}</td>
                  <td>{{ props.item.level }}</td>
                  <td>{{ `${props.item.grade} ${props.item.group}` }}</td>
                  <td>{{ props.item.personId }}</td>
                </tr>
              </template>
              <v-progress-linear
                v-slot:progress
                color="primary"
                indeterminate
              ></v-progress-linear>
              <template v-slot:no-data>
                <div>No hay registros para filtrar</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        text: 'Foto',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nombre Alumno',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Apellido Alumno',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nivel',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Grupo',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Matrícula',
        sortable: false,
        align: 'center',
      },
    ],
    items: [],
    totalItems: 0,
    isLoading: false,
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
    search: '',
  }),
  methods: {
    async getItems() {
      const params = {
        size: this.pagination.rowsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        search: this.search === '' ? undefined : this.search,
      }

      this.isLoading = true
      try {
        const { data } = await this.$store.dispatch(
          'round/getDetailStudentsRound',
          { idRound: this.$route.params.id, params }
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    clearSearch() {
      this.search = ''
      this.getItems()
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  background-color: #f9fafb;
  height: 40px;
}
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  text-transform: initial !important;
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 50vh;
}
::v-deep .v-datatable.v-table > tbody tr td {
  text-align: center;
  font-size: inherit;
  font-weight: inherit;
}
::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
